import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { SystemNotificationSize } from './system-notification-size.enum';
import { SystemNotificationType } from './system-notification-type.enum';

let $id = 0;

@Component({
  selector: 'wfm-system-notification',
  templateUrl: './system-notification.component.html',
  styleUrls: ['./system-notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SystemNotificationComponent {
  @Input() type: SystemNotificationType = SystemNotificationType.infoGeneral;

  @Input() size: SystemNotificationSize = SystemNotificationSize.medium;

  @Input() headingText: string;

  @Input() descriptionText: string;

  @Input() secondaryText: string | TemplateRef<any>;

  @Input() hideCloseButton = false;

  @Input() multiLineLayout = false;

  @Input() hideHeaderUtility = false;

  @Input() backgroundOverride = false;

  @Input() spinnerIcon = 'false';

  @Output() close = new EventEmitter();

  id = 0;

  get iconSize(): number {
    if (this.size === SystemNotificationSize.small) return 12;
    return 24;
  }

  get icon(): string {
    if (this.type === SystemNotificationType.highSeverityPrimary) return 'ico-alert-dark-24';

    if (
      this.type === SystemNotificationType.highSeverityAlternate ||
      this.type === SystemNotificationType.highSeverityAcknowledged
    )
      return 'ico-alert-24';

    if (
      this.type === SystemNotificationType.moderateSeverityPrimary ||
      this.type === SystemNotificationType.moderateSeverityAlternate ||
      this.type === SystemNotificationType.moderateSeverityAcknowledged ||
      this.type === SystemNotificationType.lowSeverityPrimary ||
      this.type === SystemNotificationType.lowSeverityAlternate ||
      this.type === SystemNotificationType.lowSeverityAcknowledged
    )
      return 'ico-error-16';

    if (this.type === SystemNotificationType.success) return 'ico-checkmark-circle-16';

    return 'ico-info-24';
  }

  get iconColor(): string {
    if (this.type === SystemNotificationType.highSeverityAcknowledged) return '#a80925';
    if (this.type === SystemNotificationType.moderateSeverityAcknowledged) return '#b05f09';
    if (this.type === SystemNotificationType.lowSeverityAcknowledged) return '#bf9f0a';
    if (this.type === SystemNotificationType.success) return '#26842F';
    if (this.type === SystemNotificationType.moderateSeverityAlternate) return '#B05F09';
    return 'currentColor';
  }

  constructor() {
    this.id = $id++;
  }
}
